<script>
  import { format } from 'svelte-i18n';
  import { Card, CardBody, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { SwitchField, TextareaField, TextField } from '@client/components/fields/standalone';

  import { disabledValue, enabledValue } from '@client/pages/manage/domain-settings';

  export let settings = {};
  export let onUpdate = null;
</script>

<div id="deliverability">
  <div class="additional-details">
    <h4>
      {@html $format('label.DELIVERABILITY_SPF')}
    </h4>

    {#if settings.checkspf === 0}
      <div class="badge badge-success">{$format('label.SPF_PASS')}</div>
    {:else if settings.checkspf > 0}
      <span class="badge badge-danger breakword">{$format('label.SPF_FAIL')}</span>
      <Icon name="help-circle" id="domain-spf-records" />
      <Tooltip target="domain-spf-records" placement="top">
        <b>{$format('label.ERROR')}</b>
        <pre>{JSON.stringify(settings.spfrecords, null, 2)}</pre>
      </Tooltip>
    {/if}

    <div>
      <code>{$format('label.SPF_EXMAPLE_RECORD')}</code>
    </div>

    <h4>{$format('label.CNAME')}</h4>

    {#if settings.cnamerecord[0] === 'whs.sendergen.com' && !settings.cname.endsWith('hosted-content.com')}
      <div class="badge badge-success">{$format('label.CNAME_WHITELABELED')}</div>
    {/if}

    {#if settings.cnamerecord[0] !== 'whs.sendergen.com' || settings.cname.endsWith('hosted-content.com')}
      <div class="badge badge-danger">{$format('label.CNAME_NOT_SET')}</div>
    {/if}
  </div>

  <h1 class="mb-3">{$format('label.GENERAL')}</h1>
  <Card>
    <CardBody class="p-4 pt-1">
      <SwitchField
        id="resetarcseals"
        label={$format('label.ARC_SEALS')}
        tooltip={$format('label.TOOLTIP.ARC_SEALS')}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        bind:checked={settings.resetarcseals}
        {onUpdate}
      />

      <TextField
        id="dmarcemail"
        label={$format('label.DMARC_ADMIN_EMAIL')}
        tooltip={$format('label.TOOLTIP.DMARC_ADMIN_EMAIL')}
        bind:value={settings.dmarcemail}
        {onUpdate}
        allowCopy
      />

      <SwitchField
        id="dkimenabled"
        label={$format('label.DKIM_ENABLED')}
        tooltip={$format('label.TOOLTIP.DKIM_ENABLED')}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        bind:checked={settings.dkimenabled}
        {onUpdate}
      />

      <TextField
        id="dkimselector"
        label={$format('label.DKIM_SELECTOR')}
        tooltip={$format('label.TOOLTIP.DKIM_SELECTOR')}
        formatValue={(value) => (value ? `${value}._domainkey.sendergen.com` : '-')}
        bind:value={settings.dkimselector}
        {onUpdate}
        allowCopy
      />

      {#if settings.dkimenabled}
        <TextareaField
          id="dkimdnsentry"
          label={$format('label.DKIM_DNS_ENTRY')}
          tooltip={$format('label.TOOLTIP.DKIM_DNS_ENTRY')}
          bind:value={settings.dkimdnsentry}
          {onUpdate}
          allowCopy
        />
      {/if}

      <TextField
        id="sclcode"
        label={$format('label.SCL_AUTH_CODE')}
        tooltip={$format('label.TOOLTIP.SCL_AUTH_CODE')}
        bind:value={settings.sclcode}
        {onUpdate}
        allowCopy
      />
    </CardBody>
  </Card>
</div>

<style lang="scss" src="./deliverabilty.scss"></style>
